import { lazy, Suspense } from "react";
import { BANNER_ASPECT_RATIO } from "app/components/OldBanner/constants";
import SideAdvertCard from "app/components/SideAdvertCard/SideAdvertCard";
import type { SideAdvert } from "app/api/advert/advert.types";

const OldBanner = lazy(() => import("app/components/OldBanner"));

interface HeroBannerProps {
  banners: any[];
  sideAdverts: SideAdvert[];
}

export function HeroBanner({ banners, sideAdverts }: HeroBannerProps) {
  if (!banners?.length && !sideAdverts?.length) {
    return null;
  }

  return (
    <div className="xl:container mx-auto xl:px-12 home-page overflow-hidden bg-gray-50 dark:bg-gray-900 w-full">
      <div className="flex flex-col lg:flex-row gap-2 py-2 w-full">
        {/* Main banner */}
        {banners?.length ? (
          <div
            className="relative z-10 flex-1 min-w-0 rounded-xl overflow-hidden"
            // style={{ aspectRatio: BANNER_ASPECT_RATIO }}
          >
            <Suspense fallback={<div className="animate-pulse bg-gray-200 h-full" />}>
              <OldBanner banners={banners} />
            </Suspense>
          </div>
        ) : null}
        {/* Side adverts: vertical stack on lg+ next to banner, or grid when no banner */}
        {sideAdverts?.length ? (
          <div
            className={
              banners?.length
                ? "hidden lg:flex flex-col gap-2 w-[200px] xl:w-[240px] flex-shrink-0 self-stretch min-h-0"
                : "grid grid-cols-2 sm:grid-cols-3 gap-2 w-full max-w-2xl mx-auto lg:mx-0 lg:max-w-none lg:w-[200px] xl:w-[240px] lg:flex lg:flex-col"
            }
          >
            {sideAdverts.slice(0, 3).map((advert: SideAdvert) => (
              <div key={advert._id} className={banners?.length ? "flex-1 min-h-0" : undefined}>
                <SideAdvertCard advert={advert} fillHeight={!!banners?.length} />
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
